import styled from 'styled-components';
import { Tabs } from 'antd';

export const StyledTabs = styled(Tabs)`
  height: 100%;

  .ant-tabs-content-holder {
    display: flex;

    .ant-tabs-tabpane {
      height: 100%;
    }
  }
`;
